import { regionsFlat } from './iso-regions'

export const isoKeyVal = [
  {
    label: 'California ISO (CAISO)',
    value: '5efdf79e2b64270017d8495e',
  },
  {
    label: 'Electric Reliability Council of Texas (ERCOT)',
    value: '5efdfe850e9fc00016ac6e0e',
  },
  {
    label: 'ISO New England (ISO-NE)',
    value: '5ef61536ce5eb5001776b321',
  },
  {
    label: 'Midcontinent ISO (MISO)',
    value: '5efce45829365900154e8fe2',
  },
  {
    label: 'New York ISO (NYISO)',
    value: '5efd11ff6671250015a90a9b',
  },
  {
    label: 'PJM Interconnection',
    value: '5efcdf1e36f87e001523b645',
  },
  {
    label: 'Southwest Power Pool (SPP)',
    value: '5efcea3b36f87e0015241668',
  },
  {
    label: 'Western Energy Imbalance Market',
    value: '5f10ba8ed5c6f500156e710b',
  },
]

export const isoRegions = isoKeyVal.map((key) => {
  return {
    label: key.label,
    value: regionsFlat[key.label],
  }
})

export const isoOptions = {
  key: 'iso',
  label: 'ISO|RTO',
  options: isoRegions,
  component: 'ContentFilter',
}
